import React, { createContext, useContext, useState } from 'react';

interface TooltipContextState {
  isShow: boolean;
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
  coords: {
    x: number;
    y: number;
  };
  setCoords: React.Dispatch<React.SetStateAction<{ x: number; y: number }>>;
  size: {
    height: number;
    width: number;
  };
  setSize: React.Dispatch<React.SetStateAction<{ height: number; width: number }>>;
}

const initialTooltipContextState: TooltipContextState = {
  isShow: false,
  setIsShow: () => null,
  coords: { x: 0, y: 0 },
  setCoords: () => null,
  size: { height: 0, width: 0 },
  setSize: () => null,
};

const TooltipContext = createContext(initialTooltipContextState);

export const TooltipContextProvider = TooltipContext.Provider;

export function useTooltipContext() {
  const context = useContext(TooltipContext);
  return context;
}

export function useTooltipContextValue() {
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const [isShow, setIsShow] = useState(false);
  const [size, setSize] = useState({ height: 0, width: 0 });

  return { coords, setCoords, isShow, setIsShow, size, setSize };
}
